import React from 'react';
import PropTypes from 'prop-types';

export default class TotalView extends React.Component {
  constructor() {
    super();
    this.handleNextClick = this.handleOnClick.bind(this, true);
    this.handleBackClick = this.handleOnClick.bind(this, false);
  }

  handleOnClick(back) {
    document.querySelector('.react-tabs').scrollIntoView();
    if (back) {
      this.props.back();
    } else {
      this.props.next();
    }
  }

  render() {
    const nextButtonMargin = !this.props.back && this.props.next ? 'startup-calculator-btn-next-alone' : '';
    return (
      <div className="startup-calculator-total-view">
        <h2>{this.props.title}</h2>
        <div className="startup-calculator-total-value">
          <span>$</span>
          {this.props.sum}
        </div>
        {(this.props.back || this.props.next) &&
          <div className="startup-calculator-btn-wrap">
            {this.props.back &&
              <div className="startup-calculator-btn-back-wrap">
                <p>Back:</p>
                <button
                  className="startup-calculator-btn-back"
                  onClick={this.handleNextClick}
                >
                  {this.props.backText}
                </button>
              </div>
            }
            {this.props.next &&
              <div className={`startup-calculator-btn-next-wrap ${nextButtonMargin}`}>
                <p>Next:</p>
                <button
                  className="startup-calculator-btn-next"
                  onClick={this.handleBackClick}
                >
                  {this.props.nextText}
                </button>
              </div>
            }
          </div>
        }
      </div>
    );
  }
}

TotalView.defaultProps = {
  back: null,
  next: null,
  backText: 'Back',
  nextText: 'Next',
};

TotalView.propTypes = {
  title: PropTypes.string.isRequired,
  sum: PropTypes.string.isRequired,
  back: PropTypes.func,
  next: PropTypes.func,
  backText: PropTypes.string,
  nextText: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src-react/StartupCalculator/components/TotalView.jsx